/**
 * totalVotes returns the total vote count in a proposal oiutc
 */
export const totalVotes = (proposal) => [proposal.for, proposal.against, proposal.abstain, proposal.brokerNonVote, proposal.withheld].reduce((acc, value) => {
    if (value === undefined) {
        return acc;
    }
    return acc + value;
}, 0);
